export const SELECTED_CHAT_SUCCESS = 'SELECTED_CHAT_SUCCESS';
export const SELECTED_CHAT_FAILED = 'SELECTED_CHAT_FAILED';
export const SELECTED_CHAT_LOADING = 'SELECTED_CHAT_LOADING';
export const GROUP_ADD_MEMBER_SUCCESS = 'GROUP_ADD_MEMBER_SUCCESS';
export const GROUP_ADD_MEMBER_FAILED = 'GROUP_ADD_MEMBER_FAILED';
export const MESSAGE_SEARCH_SELECTED = 'MESSAGE_SEARCH_SELECTED';